/**
 * Snippet palette for the Script Widget editor (Phase L4b, Cmd-J).
 *
 * These are completion items with snippet templates — pick one from the
 * palette (Cmd-J / Ctrl-J) and CodeMirror inserts the body with tab stops
 * at each `${...}` placeholder. Lifted from the most common patterns the
 * sandbox SDK supports; expand cautiously — every entry is a public
 * promise we'll have to keep working forever.
 */
import { snippetCompletion } from '@codemirror/autocomplete';

export const SCRIPT_SNIPPETS = [
  snippetCompletion(
    'ctx.bus.publish("${1:xv.OpenCase}", ${2:{ caseId: ctx.case?.id \\}});\n${0}',
    { label: 'publish-topic', detail: 'broadcast on the layout bus', type: 'snippet' },
  ),
  snippetCompletion(
    'const res = await ctx.fetch("${1:/api/.../}", { method: "${2:GET}" });\nif (!res.ok) {\n  ctx.log.error("fetch failed", res.status);\n  return null;\n}\nreturn res.json;\n${0}',
    { label: 'fetch-json', detail: 'round-trip through the /script-fetch proxy', type: 'snippet' },
  ),
  snippetCompletion(
    'ctx.invokeAction("${1:widgetId}", "${2:action}", ${3:payload});\n${0}',
    { label: 'invoke-action', detail: 'call a sibling widget action', type: 'snippet' },
  ),
  snippetCompletion(
    'ctx.log.info("${1:label}", ${2:value});\n${0}',
    { label: 'log', detail: 'log to host console (visible in DevTools)', type: 'snippet' },
  ),
  snippetCompletion(
    'const fields = ctx.case?.custom_fields || {};\n${0}',
    { label: 'case-custom-fields', detail: 'pull custom fields from the active case', type: 'snippet' },
  ),
  snippetCompletion(
    'const formatted = helpers.formatMoney(${1:value}, "${2:USD}");\n${0}',
    { label: 'format-money', detail: 'helpers.formatMoney shortcut', type: 'snippet' },
  ),
  snippetCompletion(
    'const slug = helpers.slugify(${1:string});\n${0}',
    { label: 'slugify', detail: 'helpers.slugify shortcut', type: 'snippet' },
  ),
];

/**
 * Always-available completion source: surfaces snippets when the user starts
 * typing an identifier. Cmd-J triggers explicit completion which always shows
 * them too.
 */
export function snippetCompletionSource(context) {
  const word = context.matchBefore(/[\w$]*$/);
  if (!word) return null;
  if (word.from === word.to && !context.explicit) return null;
  return {
    from: word.from,
    to: word.to,
    options: SCRIPT_SNIPPETS,
  };
}
